import React from 'react';
import { Card } from 'components/atoms';

const BorderContainerForm: React.FC = ({ children }) => {
  return <Card>{children}</Card>;
};

export default BorderContainerForm;
